import React from 'react';

import AddIcon from '@mui/icons-material/Add';
import Stack from '@mui/material/Stack';

import GuideInfoBox from '../components/GuideInfoBox';
import GuideMockButton from '../components/GuideMockButton';
import GuideMockContainer from '../components/GuideMockContainer';
import GuideMockSelect from '../components/GuideMockSelect';
import GuidePageLayout from '../components/GuidePageLayout';
import GuideSection from '../components/GuideSection';
import GuideStepList from '../components/GuideStepList';
import GuideTable from '../components/GuideTable';

const GuideFinancialYear: React.FC = () => {
  return (
    <GuidePageLayout
      title="年度を管理する"
      description="年度データの登録と年度選択機能について説明します。"
      breadcrumbs={[{ label: '年度管理', path: '/guide/financial-year/overview' }]}
    >
      {/* 次年度登録 */}
      <GuideSection title="次年度を登録する（BUC-FY01）">
        <GuideTable
          headers={['条件', '内容']}
          rows={[
            ['必要な権限', '管理者'],
            ['ログイン状態', 'ログイン済みであること'],
            ['前提', '次年度がまだ登録されていないこと'],
          ]}
        />
        <GuideStepList
          steps={[
            { label: '管理者メニューから年度管理画面を開く' },
            { label: '現在登録されている年度の一覧を確認する' },
            {
              label: '「次年度を登録」ボタンを押下する',
              content: (
                <GuideMockContainer label="次年度登録ボタン">
                  <GuideMockButton label="次年度を登録" startIcon={<AddIcon />} />
                </GuideMockContainer>
              ),
            },
          ]}
        />
        <Stack spacing={1} sx={{ mt: 2 }}>
          <GuideInfoBox>
            次年度の12ヶ月分のデータが自動的に作成されます。各月の開始日・終了日・四半期が自動設定されます。
          </GuideInfoBox>
          <GuideInfoBox>年度は3月起算（3月〜翌年2月）です。</GuideInfoBox>
          <GuideInfoBox type="warning">既に次年度が登録済みの場合はエラーになります。</GuideInfoBox>
          <GuideInfoBox type="warning">
            年度データが存在しないとセキュリティチェック等の月指定操作ができないため、年度の切り替わり前に登録してください。
          </GuideInfoBox>
        </Stack>
      </GuideSection>

      {/* 年度セレクタ */}
      <GuideSection title="年度セレクタで年度を選択する（BUC-FY02）">
        <GuideTable
          headers={['条件', '内容']}
          rows={[['ログイン状態', 'ログイン済みであること（権限不問）']]}
        />
        <GuideStepList
          steps={[
            { label: '契約管理画面やセキュリティチェック画面等を開く' },
            {
              label: '年度セレクタに自動的に年度一覧が読み込まれる',
              content: (
                <GuideMockContainer label="年度セレクタ">
                  <GuideMockSelect
                    label="年度"
                    options={['2025期', '2024期', '2023期']}
                    value="2025期"
                  />
                </GuideMockContainer>
              ),
            },
            { label: 'デフォルトで現在年度が選択される' },
            { label: '別の年度を選択すると、その年度の月一覧が更新される' },
          ]}
        />
        <Stack spacing={1} sx={{ mt: 2 }}>
          <GuideInfoBox>
            現在日時がどの年度月にも属さない場合は、デフォルト選択がnullとなり手動選択が必要です。
          </GuideInfoBox>
        </Stack>
      </GuideSection>
    </GuidePageLayout>
  );
};

export default GuideFinancialYear;
